import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { App } from 'antd'
import { getPatMedicalHistory } from '../../api/api'
import patMedHistReducer from '../../utils/reducer'
import DesktopMedicalHistory from './DesktopMedicalHistory'
import { handleError } from '../../../../lib/utils'

const DesktopMedicalHistoryWrapper = ({ isPatient }) => {
  const { message } = App.useApp()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const initializeData = async () => {
      setLoading(true)
      const startTime = Date.now()

      try {
        const data = await getPatMedicalHistory()
        dispatch(patMedHistReducer.actions.setState(data))
      } catch (error) {
        message.error(handleError(error, true))
      }

      // Ensure loading screen shows for at least 2 seconds
      const elapsedTime = Date.now() - startTime
      const minimumLoadingTime = 2000 // 2 seconds
      const remainingTime = minimumLoadingTime - elapsedTime

      if (remainingTime > 0) {
        setTimeout(() => {
          setLoading(false)
        }, remainingTime)
      } else {
        setLoading(false)
      }
    }
    initializeData()
    // eslint-disable-next-line
  }, [])

  return (
    <div className='desktop-medical-history-wrapper'>
      <DesktopMedicalHistory isPatient={isPatient} loading={loading} />
    </div>
  )
}

export default DesktopMedicalHistoryWrapper
